import React, { Component } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LOGO_VARIANTS } from '../components/LogoVariations';
export function Logos() {
  return <div className="min-h-screen w-full bg-background" data-id="element-1348">
      <AnnouncementBar data-id="element-1349" />
      <Header data-id="element-1350" />

      <main className="container mx-auto py-16 lg:py-20" data-id="element-1351">
        <div className="max-w-2xl mb-12" data-id="element-1352">
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-1353">
            Internal · Brand
          </p>
          <h1 className="text-3xl lg:text-5xl font-semibold tracking-[-0.025em] text-foreground leading-[1.05]" data-id="element-1354">
            Logo direction options<span className="text-primary" data-id="element-1355">.</span>
          </h1>
          <p className="mt-5 text-[15px] leading-relaxed text-muted-foreground" data-id="element-1356">
            Eight variations on the peptides.ml wordmark. Each preview shows the
            logo at three working sizes against both background tones, so you
            can see how it behaves in the nav, footer, and on dark surfaces.
            Pick a direction — we&apos;ll wire it across the site.
          </p>
        </div>

        <div className="grid gap-5" data-id="element-1357">
          {LOGO_VARIANTS.map(({
          id,
          name,
          description,
          Component
        }) => <article key={id} className="rounded-2xl border border-border bg-card overflow-hidden" data-id="element-1358">
              {/* Header row */}
              <div className="flex items-end justify-between gap-6 px-6 lg:px-8 pt-6 pb-5 border-b border-border" data-id="element-1359">
                <div data-id="element-1360">
                  <div className="font-mono text-[10.5px] uppercase tracking-wider text-muted-foreground font-medium mb-1.5 [font-feature-settings:'tnum']" data-id="element-1361">
                    {id.toUpperCase()}
                  </div>
                  <h2 className="text-[17px] font-semibold tracking-tight text-foreground leading-tight" data-id="element-1362">
                    {name}
                  </h2>
                  <p className="mt-1.5 text-[13px] text-muted-foreground max-w-xl leading-relaxed" data-id="element-1363">
                    {description}
                  </p>
                </div>
              </div>

              {/* Preview grid */}
              <div className="grid lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-border" data-id="element-1364">
                {/* Light surface */}
                <div className="bg-background px-6 lg:px-8 py-10 flex flex-col items-start gap-8" data-id="element-1365">
                  <div className="text-[10.5px] uppercase tracking-wider text-muted-foreground font-medium" data-id="element-1366">
                    On light surface
                  </div>
                  <div className="flex items-end gap-10 flex-wrap" data-id="element-1367">
                    <div className="flex flex-col gap-2 items-start" data-id="element-1368">
                      <Component size={18} data-id="element-1369" />
                      <span className="font-mono text-[10px] text-muted-foreground" data-id="element-1370">
                        nav (sm)
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 items-start" data-id="element-1371">
                      <Component size={26} data-id="element-1372" />
                      <span className="font-mono text-[10px] text-muted-foreground" data-id="element-1373">
                        default
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 items-start" data-id="element-1374">
                      <Component size={42} data-id="element-1375" />
                      <span className="font-mono text-[10px] text-muted-foreground" data-id="element-1376">
                        marketing (lg)
                      </span>
                    </div>
                  </div>
                </div>

                {/* Dark surface */}
                <div className="bg-foreground text-background px-6 lg:px-8 py-10 flex flex-col items-start gap-8" data-id="element-1377">
                  <div className="text-[10.5px] uppercase tracking-wider text-background/60 font-medium" data-id="element-1378">
                    On dark surface
                  </div>
                  <div className="flex items-end gap-10 flex-wrap" data-id="element-1379">
                    <div className="flex flex-col gap-2 items-start" data-id="element-1380">
                      <Component size={18} inverted data-id="element-1381" />
                      <span className="font-mono text-[10px] text-background/50" data-id="element-1382">
                        nav (sm)
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 items-start" data-id="element-1383">
                      <Component size={26} inverted data-id="element-1384" />
                      <span className="font-mono text-[10px] text-background/50" data-id="element-1385">
                        default
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 items-start" data-id="element-1386">
                      <Component size={42} inverted data-id="element-1387" />
                      <span className="font-mono text-[10px] text-background/50" data-id="element-1388">
                        marketing (lg)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12 px-5 py-4 rounded-xl bg-secondary/40 border border-border text-[13px] text-muted-foreground" data-id="element-1389">
          Once you pick a direction, reply with the variant number (e.g.{' '}
          <span className="font-mono font-semibold text-foreground" data-id="element-1390">V3</span>)
          and I&apos;ll replace the active Logo component site-wide.
        </div>
      </main>

      <Footer data-id="element-1391" />
    </div>;
}